if (typeof FN == 'undefined') FN = {};

FN.downloadDropdown = {
  instances: [],
  
  init: function() {
    const dropdownContainers = document.querySelectorAll('.button--split-dropdown');
    
    dropdownContainers.forEach(function(container) {
      const instance = new FN.downloadDropdown.Instance(container);
      FN.downloadDropdown.instances.push(instance);
    });
  },
  
  Instance: function(container) {
    this.container = container;
    this.trigger = container.querySelector('.button__dropdown-trigger');
    this.dropdown = container.querySelector('.download-dropdown');
    this.isOpen = false;
    
    this.init();
  }
};

FN.downloadDropdown.Instance.prototype = {
  init: function() {
    if (!this.trigger || !this.dropdown) {
      console.warn('Download dropdown: Missing trigger or dropdown element');
      return;
    }
    
    this.bindEvents();
  },
  
  bindEvents: function() {
    const self = this;
    
    // Toggle dropdown on trigger click
    this.trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      self.toggle();
    });
    
    // Close dropdown when clicking outside
    document.addEventListener('click', function(e) {
      if (!self.container.contains(e.target)) {
        self.close();
      }
    });
    
    // Handle keyboard navigation
    this.trigger.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        self.toggle();
      } else if (e.key === 'ArrowDown' && self.isOpen) {
        e.preventDefault();
        self.focusFirstItem();
      } else if (e.key === 'Escape') {
        self.close();
        self.trigger.focus();
      }
    });
    
    // Handle dropdown item keyboard navigation
    const dropdownItems = this.dropdown.querySelectorAll('.download-dropdown__item');
    dropdownItems.forEach(function(item, index) {
      item.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          const nextItem = dropdownItems[index + 1];
          if (nextItem) {
            nextItem.focus();
          } else {
            dropdownItems[0].focus(); // Loop to first
          }
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          const prevItem = dropdownItems[index - 1];
          if (prevItem) {
            prevItem.focus();
          } else {
            dropdownItems[dropdownItems.length - 1].focus(); // Loop to last
          }
        } else if (e.key === 'Escape') {
          self.close();
          self.trigger.focus();
        } else if (e.key === 'Tab' && !e.shiftKey && index === dropdownItems.length - 1) {
          // Close dropdown when tabbing out of last item
          self.close();
        } else if (e.key === 'Tab' && e.shiftKey && index === 0) {
          // Close dropdown when shift-tabbing out of first item
          self.close();
        }
      });
      
      // Close dropdown when item is clicked
      item.addEventListener('click', function() {
        self.close();
      });
    });
  },
  
  toggle: function() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  },
  
  open: function() {
    if (this.isOpen) return;
    
    // Close other open dropdowns
    FN.downloadDropdown.instances.forEach(function(instance) {
      if (instance !== this && instance.isOpen) {
        instance.close();
      }
    }.bind(this));
    
    this.isOpen = true;
    this.trigger.classList.add('dropdown--open');
    this.dropdown.classList.add('dropdown--open');
    this.trigger.setAttribute('aria-expanded', 'true');
    
    // Set focus to first item after a brief delay to ensure dropdown is visible
    setTimeout(function() {
      this.focusFirstItem();
    }.bind(this), 50);
  },
  
  close: function() {
    if (!this.isOpen) return;
    
    this.isOpen = false;
    this.trigger.classList.remove('dropdown--open');
    this.dropdown.classList.remove('dropdown--open');
    this.trigger.setAttribute('aria-expanded', 'false');
  },
  
  focusFirstItem: function() {
    const firstItem = this.dropdown.querySelector('.download-dropdown__item');
    if (firstItem) {
      firstItem.focus();
    }
  }
};

// Initialize on DOM ready
$(document).ready(function() {
  FN.downloadDropdown.init();
});